const HEADING = /^#{1,6}\s+/;
const QUOTE = /^>\s?/;
const LIST_ITEM = /^(?:[-*+]|\d+[.)])\s+/;
const FENCE = /^(?:```|~~~)/;
/**
 * A code span: a run of ticks, then code (ticks allowed), then a run of exactly as many ticks.
 * An unmatched run is not one; its ticks go as stray ones.
 */
const CODE_SPAN = /(?<!`)(`+)(?!`)(.+?)(?<!`)\1(?!`)/;
const INLINE: [RegExp, string][] = [
  [/!?\[([^\]]*)\]\([^)]*\)/g, "$1"], // a link or image: its text
  [/`+/g, ""], // a stray tick
  [/\*+|~~/g, ""], // bold, italic, strike
  [/(^|\W)_+|_+(?=\W|$)/g, "$1"], // underscore emphasis, not snake_case
];

const stripInline = (text: string) =>
  INLINE.reduce((out, [pattern, replacement]) => out.replace(pattern, replacement), text);

/** One line's text: its markdown gone outside code spans, the spans' code kept as written. */
function inlineText(line: string): string {
  // split keeps the captures, so the pieces go text, ticks, code, text, ticks, code, ..., text.
  return line
    .split(CODE_SPAN)
    .map((piece, index) => (index % 3 === 0 ? stripInline(piece) : index % 3 === 2 ? piece : ""))
    .join("")
    .trim();
}

/**
 * Markdown as one line of plain text, for a preview: no list markers, headings, quotes, emphasis
 * or code ticks; links as their text; code as written; list items joined with ", " and other
 * lines with a space.
 */
export function plainText(markdown: string): string {
  let text = "";
  let inList = false;
  let fenced = false;
  const append = (words: string, item: boolean) => {
    if (!words) return;
    text += text ? (item && inList ? ", " : " ") + words : words;
    inList = item;
  };
  for (const raw of markdown.split("\n")) {
    const line = raw.trim();
    if (FENCE.test(line)) {
      fenced = !fenced;
      continue;
    }
    if (fenced) {
      append(line, false);
      continue;
    }
    const item = LIST_ITEM.test(line);
    append(inlineText(line.replace(QUOTE, "").replace(HEADING, "").replace(LIST_ITEM, "")), item);
  }
  return text.replace(/\s+/g, " ").trim();
}
